import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { ModalBaseDirective } from '$core/base/_modal.component';

@Component({
  selector: 'app-batch-commit-error-modal',
  templateUrl: './batch-commit-error-modal.component.html',
  styleUrls: ['./batch-commit-error-modal.component.scss'],
})
export class BatchCommitErrorModalComponent
  extends ModalBaseDirective
  implements OnInit
{
  @Input() public errorData: {
    message: string;
    errors: {
      [key: string]: string;
    };
  };
  public formatedErrorData: string[] = [];

  public errorTitle = this.translateService.instant(
    'BATCH_MAILING.BATCHES_TAB.DEPARTURES_IN_BATCH_WITHOUT_ATTACHMENTS'
  );

  constructor(
    protected readonly modalRef: BsModalRef,
    protected readonly modalService: BsModalService,
    protected readonly translateService: TranslateService
  ) {
    super(modalRef, modalService, translateService);
  }

  public ngOnInit() {
    this.transformData(this.errorData.errors);
  }

  private transformData(errorData: { [key: string]: string }) {
    Object.entries(errorData).forEach(([key, value]) => {
      this.formatedErrorData.push(`№${key.split('.')[1]}: ${value}`);
    });
  }
}
